export const STATUS = {
    AVAILABLE: 'AVAILABLE',
    OUT_OF_STOCK: 'OUT_OF_STOCK',
    DELETED: 'DELETED',
}
